import { Button, ButtonTheme } from '@apply/components';

export const CloseButton = () => {
    return (
        <>
            <Button
                id='closeButton'
                theme={ButtonTheme.LinkBlue}
                type='button'
                handleClick={() => (window.location.href = '/')}
            >
                Close
            </Button>
        </>
    );
};
